const ASSET_VERSION = "palette-v5";
export const productImageUrl = (image, width = 3200, retry = 0) => {
  const path = image.split("?")[0];
  return `${width===3200?path:path.replace(/\.webp$/,`-${width}.webp`)}?v=${ASSET_VERSION}&retry=${retry}`;
};

export const ProductImage = ({ image, sizes = "(max-width:640px) calc(100vw - 40px), (max-width:1024px) calc(100vw - 80px), 1120px", priority = false, retry = 0, ...props }) => (
  <img src={productImageUrl(image,1600,retry)} srcSet={[800,1600,3200].map(w=>`${productImageUrl(image,w,retry)} ${w}w`).join(", ")}
    sizes={sizes} width="3200" height="2000" loading={priority?"eager":"lazy"} fetchPriority={priority?"high":"auto"} decoding="async" {...props}/>
);